/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/

import { ComponentsOverrides, ComponentsProps, ComponentsVariants } from '@mui/material';

import { CIColors } from 'shared';

type MuiIconButtonComponent = {
  defaultProps?: ComponentsProps['MuiIconButton'];
  styleOverrides?: ComponentsOverrides['MuiIconButton'];
  variants?: ComponentsVariants['MuiIconButton'];
};

export const IconButtonComponent: MuiIconButtonComponent = {
  styleOverrides: {
    root: {
      color: CIColors.GraphicElements,
      '&:hover': {
        color: CIColors.GraphicElementsHover,
        backgroundColor: 'transparent',
      },
      '&.Mui-disabled': {
        opacity: '.5',
        cursor: 'not-allowed',
      },
    },
    colorPrimary: {
      color: CIColors.Primary,
    },
  },
};
